import React from 'react';
import Hero from '../components/Hero';
import ProductSection from '../components/ProductSection';
import CooperativeBrands from '../components/CooperativeBrands';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <Hero />
      <ProductSection />
      <CooperativeBrands />
    </div>
  );
};

export default HomePage;
